import { Translation } from '@ps/web-shared-components';
import React from 'react';

import Container from '../../../Container/Container';

import {
  TXTWCL_ItXs_the_time_you_spend_at_the_ELL,
  TXTWCL_Poker_Time_Limit,
  TXTWCL_Responsible_Gaming_Limits,
  TXTWCL_Your_weekly_time_starts_every__ELL
} from './RMFPokerTimeLimit.messages.json';
import PokerSlider from './components/PokerSlider/PokerSlider';

const RMFPokerTimeLimit: React.FC = () => (
  <Container
    page={RMFPokerTimeLimit}
    headerProps={{
      title: <Translation {...TXTWCL_Responsible_Gaming_Limits} />
    }}
    pageTopTitle={<Translation {...TXTWCL_Poker_Time_Limit} />}
    pageTopSubtitle={
      <>
        <Translation {...TXTWCL_ItXs_the_time_you_spend_at_the_ELL} />{' '}
        <Translation {...TXTWCL_Your_weekly_time_starts_every__ELL} />
      </>
    }
  >
    <title>
      <Translation {...TXTWCL_Responsible_Gaming_Limits} />
    </title>
    <PokerSlider />
  </Container>
);

RMFPokerTimeLimit.displayName = 'RMFPokerTimeLimit';

export default RMFPokerTimeLimit;
